import { render, staticRenderFns } from "./register-confirm.vue?vue&type=template&id=78706902&scoped=true&"
import script from "./register-confirm.vue?vue&type=script&lang=js&"
export * from "./register-confirm.vue?vue&type=script&lang=js&"
import style0 from "./register-confirm.vue?vue&type=style&index=0&id=78706902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78706902",
  null
  
)

export default component.exports